import 'antd/dist/antd.css';
import { appService } from 'common/services/app.service';
import { Provider } from 'mobx-react';
import PWAGenerator from 'PWA/pwa-generator';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { stores } from 'stores';
import styled, { createGlobalStyle, ThemeProvider } from 'styled-components';
import { getThemeByPartner } from 'common/utils/style.util';
import App from './App';
import './index.css';
import {
  FALLBACK_PARTNER,
  DISONA_PARTNER,
} from './common/constants/trading.constants';
import { ReactComponent as CloseIconUrl } from 'themes/disonaTheme/icons/common/custom-notification-close.svg';
import { STACK_MODAL_Z_INDEX } from './Components/StackModal';
import { createRoot } from 'react-dom/client';

appService.initApp();

const GlobalTooltipStyle = createGlobalStyle`
  html, body, #root  {
    height: 100%;
    min-height: 100%;
    height: -webkit-fill-available;
  }

  a {
    color: #2D9CDB;
    text-decoration: none;
  }

  h1,h2,h3,h4,h5,h6,p {
    margin: 0;
    padding: 0;
  }

  *, *:before, *:after {
      box-sizing: border-box;
  }

  .tippy-tooltip {
    background: #e8ebf2 !important;
    color: #303742 !important;
    padding: 12px 8px;
    font-size: 12px;
    border-radius: 4px;
  }

  .tippy-popper[x-placement^=bottom] [x-arrow] {
    border-bottom-color:  #e8ebf2 !important;
  }

  .ReactModal__Overlay {
    display:flex;
    justify-content:center;
    align-items:center;
  }

  .ReactModal__Content {
    transform: none !important;
    top: auto !important;
    left: auto !important;
    bottom: auto !important;
    right: auto !important;
  }
`;

const DisonaContainer = styled(ToastContainer)`
  width: 370px;
  height: 50px;
  right: 58px;
  z-index: 999999999999;
  &.Toastify__toast-container{
    width: 370px;
    z-index: ${STACK_MODAL_Z_INDEX + 1};
  }
  &.Toastify__toast-container--top-right {
    right: 2em;
  }
  .Toastify__toast--success {
    width: 370px;
    min-height: unset;
    height: 50px;
    display: flex;
    align-items: center;
    background: #00a4af;
    box-shadow: 0 100px 80px rgba(0, 13, 38, 0.07), 0 41.7776px 33.4221px rgba(0, 13, 38, 0.0503198),
      0 22.3363px 17.869px rgba(0, 13, 38, 0.0417275), 0 12.5216px 10.0172px rgba(0, 13, 38, 0.035),
      0 6.6501px 5.32008px rgba(0, 13, 38, 0.0282725),
      0 2.76726px 2.21381px rgba(0, 13, 38, 0.0196802);
    border-radius: 10px;
    padding: 0 0 0 20px;
    margin-bottom: 10px;
    & svg {
      stroke: #00a4af;
      width: 10px;
      height: 10px;
    }

    @media(max-width: 480px) {
      top: 20px;
      width: calc(100vw - 60px);
      right: -20px;
    });
  }
  .Toastify__toast--error {
    width: 370px;
    min-height: 50px;
    display: flex;
    align-items: center;
    background: #d71a47;
    box-shadow: 0 100px 80px rgba(0, 13, 38, 0.07), 0 41.7776px 33.4221px rgba(0, 13, 38, 0.0503198),
      0 22.3363px 17.869px rgba(0, 13, 38, 0.0417275), 0 12.5216px 10.0172px rgba(0, 13, 38, 0.035),
      0 6.6501px 5.32008px rgba(0, 13, 38, 0.0282725),
      0 2.76726px 2.21381px rgba(0, 13, 38, 0.0196802);
    border-radius: 10px;
    padding: 10px 0 10px 20px;
    margin-bottom: 10px;
    & svg {
      stroke: #d71a47;
      width: 10px;
      height: 10px;
    }

    @media(max-width: 480px) {
      top: 20px;
      width: calc(100vw - 40px);
      right: -20px;
    });
  }
  .Toastify__close-button {
    width: 20px;
    height: 20px;
    background: #ffffff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
  }
  .Toastify__close-button--error {
    color: #d71a47;
  }
  .Toastify__close-button--success {
    color: #00a4af;
  }
  .Toastify__toast-body {
    font-size: 13px;
    line-height: 16px;
    text-transform: uppercase;
    font-family: 'Founders Grotesk Mono', serif;
    font-weight: 400;

    @media(max-width: 480px) {
      font-size: 11px;
      font-weight: 400;
      line-height: 14px;
      letter-spacing: 0;
      text-align: left;
    }
  }
  .close-button {
    width: 20px;
    height: 20px;
    background: #ffffff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
  }
  .Toastify__progress-bar {
    opacity: 0 !important;
  }
`;

const CloseButton = ({ closeToast }) => (
  <i className="close-button" onClick={closeToast}>
    <CloseIconUrl />
  </i>
);

const theme = getThemeByPartner();

const root = createRoot(document.getElementById('root'));

root.render(
  <Provider {...stores}>
    <ThemeProvider theme={theme}>
      <>
        <PWAGenerator />
        <GlobalTooltipStyle />
        <App />
        <ToastContainer enableMultiContainer containerId={FALLBACK_PARTNER} />
        <DisonaContainer
          enableMultiContainer
          containerId={DISONA_PARTNER}
          closeButton={<CloseButton />}
          autoClose={5000}
        />
      </>
    </ThemeProvider>
  </Provider>
);
